/**
 * SELWM-18: Scroll to top of apply form when changing pages
 * in the multi-step Advanced Forms career application.
 *
 * Hooks into the ACF action exposed by Advanced Forms plugin.
 * The `acf` global is loaded by Advanced Forms on pages with a form.
 */
document.addEventListener("DOMContentLoaded", function () {
  if (typeof acf === "undefined") return;

  acf.addAction("af/form/page_changed", function () {
    var target = document.getElementById("apply-form");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });
});
